/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const vcro = {
    userRiskScore: 	r => require.ensure([], () => r(require('./components/user_risk_score')), 	'vcro-bundle'),
    organisationRiskScore: 	r => require.ensure([], () => r(require('./components/organisation_risk_score')), 	'vcro-bundle'),
    departmentRiskScore: 	r => require.ensure([], () => r(require('./components/department_risk_score')), 	'vcro-bundle'),
    alldepartment:    r => require.ensure([], () => r(require('./components/all_department_risk_score')),    'vcro-bundle'),
    allgroup:    r => require.ensure([], () => r(require('./components/all_group_risk_score')),    'vcro-bundle'),
    allusers:    r => require.ensure([], () => r(require('./components/all_user_risk_score')),    'vcro-bundle'),
    groupRiskScore:     r => require.ensure([], () => r(require('./components/group_risk_score')),    'vcro-bundle'),
};



export default [
      {
            name: 'vcro.user_risk_score',
            path: '/vcro/user-risk-score/:id',
            component: vcro.userRiskScore,
      },
      {
            name: 'vcro.organisation_risk_score',
            path: '/vcro/organisation-risk-score',
            component: vcro.organisationRiskScore,
      },
      {
            name: 'vcro.department_risk_score',
            path: '/vcro/department-risk-score/:id',
            component: vcro.departmentRiskScore,
      },
      {
            name: 'vcro.all_department_risk_score',
            path: '/vcro/all-departments-risk-score',
            component: vcro.alldepartment,
      },
      {
            name: 'vcro.all_group_risk_score',
            path: '/vcro/all-groups-risk-score',
            component: vcro.allgroup,
      },
      {
            name: 'vcro.all_user_risk_score',
            path: '/vcro/all-users-risk-score',
            component: vcro.allusers,
      },
      {
            name: 'vcro.group_risk_score',
            path: '/vcro/group-risk-score/:id',
            component: vcro.groupRiskScore,
      },
  
]





// WEBPACK FOOTER //
// ./src/app/vcro/routes.js